import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateRangeComponent } from './date-range.component';
import { MatInputModule, MatButtonModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

@NgModule({
  declarations: [
    DateRangeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    TranslateModule,
    NgxDaterangepickerMd
  ],
  exports: [
    DateRangeComponent
  ]
})
export class PPlusDateRangeModule { }
